

































import { Component, Watch } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import UserApi from '@/services/rest/bemob/user';
import BillingApi from '@/services/rest/bemob/billing';

type WarningState = 90 | 100 | 200

@Component({
  components: {
    FormOverlay,
    DialogForm,
  }
})

export default class FreeEventsLimit extends Form {
  active: boolean = false;
  tachometerIcon: string = '';
  tachometerColor: string = '';
  modalTitle: string = '';
  text: string = '';
  warningState: WarningState;
  userApi: UserApi = new UserApi();
  billingApi: BillingApi = new BillingApi();

  billing = {} as Billing.Subscription;

  warningStateCalculate() {
    const {
      eventsUsed,
      eventsIncluded,
    } = this.$store.state.billing;

    const {eventUsageWarningStatus} = this.$store.state.user;
    const percent = eventsUsed * 100 / eventsIncluded;

    if (percent >= 200 && ![200].includes(eventUsageWarningStatus)) {
      return 200;
    }

    if (percent < 200 && percent >= 100 && ![100,200].includes(eventUsageWarningStatus)) {
      return 100;
    }

    if (percent < 100 && percent >= 90 && ![90,100,200].includes(eventUsageWarningStatus)) {
      return 90;
    }

    return null;
  }
  
  @Watch('$store.state.billing')
  onBillingChanged() {
    this.warningStateUpdate()
  }

  warningStateUpdate(){
    const { hasSuccessPayment, eventUsageWarningStatus, isMember} = this.$store.state.user;

    if (hasSuccessPayment === 0 || eventUsageWarningStatus === -1 || isMember) {
      return this.active = false;
    }

    this.warningState = this.warningStateCalculate();

    if(this.warningState){
      this.updateText()
      this.active = true;
      this.$nextTick(()=> {
        const subscriptionLink = document.querySelector('#goToSubscription');
        if(subscriptionLink){
          subscriptionLink.addEventListener('click',this.goToSubscription)
        }
      })
    }else {
      this.active = false;
    }
  }

  updateText() {
    switch (this.warningState){
      case 90: {
        this.modalTitle = this.t('Events Limit');
        this.tachometerIcon = 'fa-tachometer-alt-fast';
        this.text = this.t('You’ve Used 90% of Your Event Limit<br>Once you reach 100%, <b>overage charges</b> will begin to apply. <br>To save on tracking costs, we recommend <button id="goToSubscription">upgrading to a plan</button> with a higher event limit.<br><b>Good news:</b>Your traffic won’t be interrupted when you hit the limit — your campaigns will continue running smoothly.<br>If you need help choosing the right plan, feel free to reach out to us via live chat.');
        return this.tachometerColor = this.$colors.sunglow;
      }
      case 100: {
        this.modalTitle = this.t('Events Limit');
        this.tachometerIcon = 'fa-tachometer-alt-fastest';
        this.text = this.t('You’ve Used {0}% of Events <br>As of now, overage charges are applying and should be paid at the end of billing period.<br>To keep your tracking budget under control, we highly recommend <button id="goToSubscription">upgrading to a plan</button> with more events included. <br>You can continue on the current plan —  <b>your campaigns continue running without any disruption</b>.<br>If you need help choosing the right plan, feel free to reach out to us via live chat.',[100]);
        return this.tachometerColor = this.$colors.red;
      }
      case 200: {
        this.modalTitle = this.t('Events Limit');
        this.tachometerIcon = 'fa-tachometer-alt-fastest';
        this.text = this.t('You’ve Used {0}% of Events <br>As of now, overage charges are applying and should be paid at the end of billing period.<br>To keep your tracking budget under control, we highly recommend <button id="goToSubscription">upgrading to a plan</button> with more events included. <br>You can continue on the current plan —  <b>your campaigns continue running without any disruption</b>.<br>If you need help choosing the right plan, feel free to reach out to us via live chat.',[200]);
        return this.tachometerColor = this.$colors.red;
      }
    }}

  beforeDestroy() {
     document.querySelector('#goToSubscription')?.removeEventListener('click',this.goToSubscription);
  }

  close() {
    this.active = false;

    this.$store.commit('updateUser', {
      ...this.$store.state.user,
      eventUsageWarningStatus:this.warningState
    });

    return this.userApi.putUser({
      eventUsageWarningStatus:this.warningState
    }).then((res: any) => {
      this.$store.commit('updateUser', res);
    });
  }

  goToSubscription() {
    this.close();
    this.$router.push('/app/profile/subscription')
  }
}
